import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SeahorseModule } from '@seahorse/domain';
import { ShToggleComponent } from '@seahorse/components';

/**
 * The module configuration card of the details page: the active toggle.
 * A change is applied to the module and announced through
 * `seahorseModuleChange`; the page saves it.
 */
@Component({
  selector: 'su-seahorse-module-configuration-card',
  templateUrl: './seahorse-module-configuration-card.component.html',
  imports: [CommonModule, TranslateModule, ShToggleComponent],
})
export class SeahorseModuleConfigurationCardComponent {
  @Input() seahorseModule: SeahorseModule | null;
  @Input() saving = false;
  @Output() seahorseModuleChange = new EventEmitter();

  setActive(isActive: boolean) {
    this.seahorseModule.isActive = isActive;
    this.seahorseModuleChange.emit();
  }
}
